import { render, staticRenderFns } from "./CompleteIdIdentification.vue?vue&type=template&id=b740b1d4"
import script from "./CompleteIdIdentification.vue?vue&type=script&lang=js"
export * from "./CompleteIdIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports